module.exports = __webpack_public_path__ + "static/media/image-howto-1.647a91e9.jpg";